// extracted by css-extract-rspack-plugin
export default {"wrapper":"_e6960e20"};